<template>
  <dx-popup
    :visible="visible"
    :title="getTitle"
    :width="800"
    :height="getModelHeight"
    :showCloseButton="false"
    :dragEnabled="false"
    :resizeEnabled="false"
    @hidden="onPopupHide"
    @shown="onPopupShown"
    :wrapper-attr="{
      class: 'css-v2 gc-popup gc-popup-copy-bom',
    }"
  >
    <DxToolbarItem
      v-for="(item, index) in getToolbarItems"
      :key="index"
      :widget="item.widget"
      :location="item.location"
      :visible="item.visible"
      :toolbar="item.position"
      :options="item.options"
      :template="item.template ? item.template : null"
    />
    <template #content>
      <div tabindex="0" ref="mainDiv">
        <div class="current-bom css-v2 gc-popup-form">
          <gc-form
            :form-options="{
              gcLabelLocation: 'left',
            }"
            ref="gc-header-form"
            :form-items="getCurrentBOMFormItems"
            :is-normal="true"
            :data-model.sync="model"
            :form-mode="'review'"
            :from-from="'gc-header-form-d-a'"
            :form-height="getFormHeight"
          >
          </gc-form>
        </div>

        <div class="new-bom css-v2 gc-popup-form">
          <gc-form
            :form-options="{
              gcLabelLocation: 'left',
            }"
            ref="gc-header-form-new-bom"
            :form-items="getNewBOMFormItems"
            :is-normal="true"
            :data-model.sync="newBOMModel"
            :form-mode="'create'"
            :from-from="'gc-header-form-d-a'"
            :form-height="getFormHeight + 15"
            :valueChangeCallBack="valueChangeCallBack"
            :checkValid="isValid"
          >
          </gc-form>
        </div>

        <DxLoadPanel
          :position="{ of: '#container-wrapper' }"
          :visible.sync="loadingVisible"
          :show-indicator="true"
          :show-pane="true"
          :shading="true"
          :hide-on-outside-click="false"
          shading-color="rgba(0,0,0,0.3)"
        />
      </div>
    </template>
  </dx-popup>
</template>
<script>
import { IsResponseDataValid } from "../../_helpers/ui/helpers";
import { BillOfMaterialsService } from "../../_services/api/production/bill-of-materials.service";
import { ProductService } from "../../_services/api/products/product.service";
import { mapGetters } from "vuex";

export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: "Copy BOM",
    },
    popUpConfig: {
      type: Object,
      default: () => ({}),
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
    displayValidationSummary: {
      type: Function,
      default: () => {},
    },
    displayServerError: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        BillNo: null,
        BillType: null,
        Description1: null,
        Description2: null,
        ProductCode: null,
        ProductDescription1: null,
        ProductDescription2: null,
      },
      newBOMModel: {
        BillNo: null,
        BillType: null,
        Description1: null,
        Description2: null,
        ProductCode: null,
        ProductDescription1: null,
        ProductDescription2: null,
      },
      loadingVisible: false,
      isValid: false,
      SaveType: undefined,
    };
  },
  methods: {
    /**
     * On Popup Hide
     */
    onPopupHide() {
      this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
      this.$emit("setCopyBOMVisible", false);
    },

    /**
     * On Popup Shown
     */
    async onPopupShown() {
      this.$store.dispatch("hotKey/setHotKeyPopupMode", true);
      this.loadingVisible = true;
      this.model = { ...this.popUpConfig };
      this.newBOMModel.BillType = JSON.parse(
        JSON.stringify(this.popUpConfig.BillType)
      );

      Object.assign(this.newBOMModel, {
        Description1: this.popUpConfig.Description1,
        Description2: this.popUpConfig.Description2,
      });

      if (this.IsBOMAndProduct) {
        if (this.model.ProductCode) await this.getProductDetails();
      }

      this.$nextTick(() => {
        this.loadingVisible = false;
        this.focusOnForm();
      });
    },

    /**
     * On Cancel Popup Handler
     */
    async onCancelPopupHandler() {
      const confirm = await this.$confirm(
        `You have unsaved changes. Are you sure you want to leave?`,
        "Unsaved changes",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
        }
      );
      if (confirm) {
        this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
        this.$emit("setCopyBOMVisible", false);
      }
    },

    /**
     * Focus On Form
     */
    focusOnForm() {
      setTimeout(() => {
        this.$nextTick(() => {
          if (
            this.$refs["gc-header-form-new-bom"] &&
            this.$refs["gc-header-form-new-bom"].$refs["gc-form-comp"]
          ) {
            const formInstance =
              this.$refs["gc-header-form-new-bom"].$refs["gc-form-comp"]
                .instance;
            if (formInstance) {
              const firstElement = formInstance.getEditor("BillNo");
              if (firstElement) {
                firstElement.focus();
              }
            }
          }
        });
      }, 150);
    },

    /**
     * on Bill No Value Changed
     * @param {*} e
     */
    async onBillNoValueChanged(e) {
      if (e.event) {
        try {
          const response = await BillOfMaterialsService.getByCode(
            e.value,
            "Code,RecordId"
          );
          if (IsResponseDataValid(response)) {
            await this.$alert(
              "Bill of Materials with this Bill No already exists.",
              "Validation Error"
            );
            this.newBOMModel.BillNo = null;
            this.$nextTick(() => {
              setTimeout(() => {
                this.focusOnForm();
              }, 100);
            });
          }
        } catch (error) {
          this.displayServerError(error, "Error validating Bill of Materials");
        }
      }
    },

    /**
     * on Product Code Value Changed
     * @param {*} e
     */
    async onProductCodeValueChanged(e) {
      if (!e.event) return;

      const product = await this.fetchProductByCode(e.value);

      if (product) {
        await this.$alert(
          "Product with this Product Code already exists.",
          "Validation Error"
        );

        this.newBOMModel.ProductCode = null;

        this.$nextTick(() => {
          setTimeout(() => e.component.instance().focus(), 100);
        });
      }
    },

    /**
     * Get Product Details
     */
    async getProductDetails() {
      const product = await this.fetchProductByCode(this.model.ProductCode);

      if (product) {
        Object.assign(this.model, {
          ProductDescription1: product.Description1,
          ProductDescription2: product.Description2,
        });

        Object.assign(this.newBOMModel, {
          ProductDescription1: product.Description1,
          ProductDescription2: product.Description2,
        });
      }
    },

    /**
     * Fetch product by code
     * @param {string} code
     * @returns {object|null} product or null
     */
    async fetchProductByCode(code) {
      try {
        const response = await ProductService.getByCode(code, {
          select: "Code,Description1,Description2",
        });

        if (IsResponseDataValid(response) && response.data.value.length > 0) {
          return response.data.value[0];
        }

        return null;
      } catch (error) {
        this.displayServerError(error, "Error fetching Product details");
        return null;
      }
    },

    /**
     * Update Form Values
     * @param dataField Data Field
     * @param value Value
     */
    updateFormValues(dataField, value) {
      const form = this.$refs["gc-header-form"].$refs["gc-form-comp"].instance;
      form.beginUpdate();
      form.updateData(dataField, value);
      form.endUpdate();
    },

    /**
     * Save Handler
     */
    onSaveHandler(e) {
      if (!e) return;

      const itemData = e.itemData;
      if (!itemData || !itemData.text) return;
      this.SaveType = itemData.text;
      this.isValid = true;
    },

    /**
     * Value Change Call Back
     * @param isValid Validation Status
     * @param brokenRules
     */
    async valueChangeCallBack(isValid, brokenRules) {
      // Store the current SaveType before any async operations
      const currentSaveType = this.SaveType;

      var validations = "";

      if (!isValid) {
        brokenRules.forEach((element) => {
          validations += `<div style="width: 400px;">${element.message}</div>`;
        });

        try {
          await this.$alert(validations, "Validation Error", {
            width: 400,
          });
        } catch (error) {
          // User might have pressed ESC, but we still need to reset
        }

        // Reset SaveType when validation fails
        this.SaveType = undefined;

        this.$nextTick(() => {
          this.$refs["mainDiv"].focus();
        });
      } else {
        // Restore SaveType in case it was cleared
        this.SaveType = currentSaveType;
        await this.SaveCopyBOM();
      }

      // Always reset isValid after processing
      this.$nextTick(() => {
        this.isValid = false;
      });
    },

    /**
     * Save Copy BOM
     */
    async SaveCopyBOM() {
      this.showLoading(true);
      try {
        const response = await BillOfMaterialsService.saveCopyBOM(
          this.IsBOMAndProduct,
          this.getPayload()
        );

        if (response) {
          this.$notify(`BOM copied successfully.`, "success");
        }

        this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
        await this.$nextTick();

        if (this.SaveType === "Save & Preview") {
          this.$emit("reloadBOMDetails", this.newBOMModel.BillNo);
          this.$nextTick(() => {
            this.$emit("setCopyBOMVisible", false);
            this.$router
              .push({
                name: "bill-of-materials-review",
                params: { id: this.newBOMModel.BillNo },
              })
              .then(() => {
                this.$nextTick(() => {
                  this.$emit("reloadBOMDetails", this.newBOMModel.BillNo);
                });
              });
          });
        } else {
          this.$emit("setCopyBOMVisible", false);
          this.$emit("refreshList");
        }
      } catch (error) {
        this.displayServerError(error, "Error saving Copy BOM");
      } finally {
        this.showLoading(false);
      }
    },

    getPayload() {
      if (this.IsBOMAndProduct) {
        return {
          SourceBomCode: this.model.BillNo,
          NewBomCode: this.newBOMModel.BillNo,
          NewProductCode: this.newBOMModel.ProductCode,
          BillType: this.newBOMModel.BillType,
          Description1: this.newBOMModel.Description1,
          Description2: this.newBOMModel.Description2,
          ProductDescription1: this.newBOMModel.ProductDescription1,
          ProductDescription2: this.newBOMModel.ProductDescription2,
          ActivateBill: true,
        };
      } else {
        return {
          SourceBomCode: this.model.BillNo,
          NewBomCode: this.newBOMModel.BillNo,
          BillType: this.newBOMModel.BillType,
          Description1: this.newBOMModel.Description1,
          Description2: this.newBOMModel.Description2,
          ActivateBill: true,
        };
      }
    },
  },
  computed: {
    ...mapGetters({ getHotKeySave: "hotKey/getHotKeySave" }),
    /**
     * Get Current BOM Form Items
     * @returns
     */
    getCurrentBOMFormItems() {
      return [
        {
          itemType: "group",
          caption: this.IsBOMAndProduct
            ? "Current BOM & Product"
            : "Current BOM",
          colCount: 1,
          cssClass: "gc-form-group",
          items: [
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  dataField: "BillNo",
                  label: {
                    text: "Bill No",
                  },
                  editorType: "dxTextBox",
                  editorOptions: {
                    readOnly: true,
                    tabIndex: -1,
                  },
                },
                {
                  screenField: "BillType",
                  dataField: "BillType",
                  editorOptions: {
                    readOnly: true,
                    tabIndex: -1,
                  },
                },
                {
                  screenField: "Description",
                  dataField: "Description1",
                  label: {
                    text: "Description 1",
                  },
                  editorOptions: {
                    readOnly: true,
                    tabIndex: -1,
                  },
                },
                {
                  screenField: "Description",
                  dataField: "Description2",
                  label: {
                    text: "Description 2",
                  },
                  editorOptions: {
                    readOnly: true,
                    tabIndex: -1,
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              visible: this.IsBOMAndProduct,
              items: [
                {
                  dataField: "ProductCode",
                  label: {
                    text: "Product",
                  },
                  editorType: "dxTextBox",
                  editorOptions: {
                    readOnly: true,
                    tabIndex: -1,
                  },
                  cssClass: "margin-top",
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              visible: this.IsBOMAndProduct,
              items: [
                {
                  screenField: "Description",
                  dataField: "ProductDescription1",
                  label: {
                    text: "Description 1",
                  },
                  editorOptions: {
                    readOnly: true,
                    tabIndex: -1,
                  },
                  cssClass: "margin-top",
                },
                {
                  screenField: "Description",
                  dataField: "ProductDescription2",
                  label: {
                    text: "Description 2",
                  },
                  editorOptions: {
                    readOnly: true,
                    tabIndex: -1,
                  },
                  cssClass: "margin-top",
                },
              ],
            },
          ],
        },
      ];
    },

    /**
     * Get New BOM Form Items
     * @returns
     */
    getNewBOMFormItems() {
      return [
        {
          itemType: "group",
          caption: this.IsBOMAndProduct ? "New BOM & Product" : "New BOM",
          colCount: 1,
          cssClass: "gc-form-group",
          items: [
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  dataField: "BillNo",
                  label: {
                    text: "Bill No",
                  },
                  editorType: "dxTextBox",
                  editorOptions: {
                    tabIndex: 1,
                    maxLength: 20,
                    onValueChanged: this.onBillNoValueChanged,
                  },
                  required: true,
                },
                {
                  screenField: "BillType",
                  dataField: "BillType",
                  editorOptions: {
                    tabIndex: 2,
                  },
                  required: true,
                },
                {
                  screenField: "Description",
                  dataField: "Description1",
                  label: {
                    text: "Description 1",
                  },
                  editorOptions: {
                    tabIndex: 3,
                    maxLength: 200,
                  },
                  required: true,
                },
                {
                  screenField: "Description",
                  dataField: "Description2",
                  label: {
                    text: "Description 2",
                  },
                  editorOptions: {
                    tabIndex: 4,
                    maxLength: 200,
                  },
                },
              ],
            },

            {
              itemType: "group",
              caption: "",
              colCount: 2,
              visible: this.IsBOMAndProduct,
              items: [
                {
                  dataField: "ProductCode",
                  label: {
                    text: "Product",
                  },
                  editorType: "dxTextBox",
                  editorOptions: {
                    tabIndex: 5,
                    onValueChanged: this.onProductCodeValueChanged,
                    maxLength: 20,
                  },
                  cssClass: "margin-top",
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              visible: this.IsBOMAndProduct,
              items: [
                {
                  screenField: "Description",
                  dataField: "ProductDescription1",
                  label: {
                    text: "Description 1",
                  },
                  editorOptions: {
                    tabIndex: 6,
                    maxLength: 200,
                  },
                  required: true,
                  cssClass: "margin-top",
                },
                {
                  screenField: "Description",
                  dataField: "ProductDescription2",
                  label: {
                    text: "Description 2",
                  },
                  editorOptions: {
                    tabIndex: 7,
                    maxLength: 200,
                  },
                  cssClass: "margin-top",
                },
              ],
            },
          ],
        },
      ];
    },

    /**
     * Get Toolbar Items
     * @returns
     */
    getToolbarItems() {
      return [
        {
          widget: "dxDropDownButton",
          location: "after",
          toolbar: "top",
          options: {
            text: "Save",
            onItemClick: this.onSaveHandler,
            items: [
              {
                text: "Save & Preview",
              },
              {
                text: "Save",
              },
            ],
            keyExpr: "text",
            displayExpr: "text",
            showArrowIcon: true,
            dropDownOptions: {
              minWidth: 120,
            },
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: true,
          options: {
            icon: "close",
            onClick: this.onCancelPopupHandler,
          },
        },
      ];
    },

    /**
     * Get Title
     */
    getTitle() {
      if (this.IsBOMAndProduct) {
        return "Copy BOM & Product";
      } else {
        return "Copy BOM";
      }
    },

    /**
     * Check Is BOM And Product
     */
    IsBOMAndProduct() {
      return this.popUpConfig && this.popUpConfig.CopyType === "BOMAndProduct";
    },

    /**
     * Get Model Height
     */
    getModelHeight() {
      return this.IsBOMAndProduct ? 555 : 415;
    },

    getFormHeight() {
      return this.IsBOMAndProduct ? 200 : 130;
    },
  },
  watch: {
    getHotKeySave: {
      handler(val) {
        if (val) {
          this.$store.dispatch("hotKey/setHotKeySave", false);
          this.$nextTick(() => {
            // Set SaveType to "Save & Preview"
            this.SaveType = "Save & Preview";
            // Trigger validation which will call valueChangeCallBack
            this.isValid = true;
          });
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.gc-popup-copy-bom {
  .dx-toolbar.dx-popup-title {
    height: 60px;
  }
  .dx-toolbar-after {
    > div:first-child.dx-item.dx-toolbar-button {
      div.dx-button {
        border-radius: 2px !important;
        background-color: #03a9f4;
        color: #fff;
        -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.24);
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.24);
        .dx-icon.dx-icon-spindown.dx-icon-right {
          margin-left: unset !important;
          color: #fff;
        }

        .dx-icon.dx-icon-spindown.dx-icon-right::before {
          color: #fff;
        }
      }
    }
  }

  .dx-form {
    .gc-form-group {
      .dx-form-group-caption {
        font-family: Roboto;
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0%;
        color: var(--colors-text-text-primary-900, #101828);
      }
    }
  }

  .new-bom {
    padding-top: unset !important;
  }

  .margin-top {
    margin-top: 10px;
  }
}
</style>
